import React from 'react';
import { get } from 'lodash';
import { Text, useShowContext } from 'ui-builder';
import { formatBytes } from 'nekst-api';
import { TextStyle } from 'react-native';

export function FileSizeField(
  props: {
    source: string,
    // eslint-disable-next-line react/no-unused-prop-types
    label: string,
    style?: TextStyle,
  },
) {
  const showContext = useShowContext();

  const value = get(showContext.data, props.source);

  if (value) {
    return (<Text style={props.style}>{formatBytes(value)}</Text>);
  } else {
    return (<Text style={props.style}>-</Text>);
  }
}
